import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-password',
  template: `
    <div class="flex items-center relative">
      <input
        pInputText
        #passwordField
        type="password"
        [formControl]="control"
        [placeholder]="props.placeholder"
      />
      <a (click)="toggle()" class="absolute cursor-pointer">{{
        show ? 'Hide' : 'Show'
      }}</a>
    </div>
  `,
  styles: [
    `
      a {
        right: 14px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyPasswordComponent extends FieldType {
  @ViewChild('passwordField', { static: false }) passwordField: ElementRef;
  show = false;

  get control(): FormControl {
    return this.formControl as FormControl;
  }

  constructor() {
    super();
  }

  toggle() {
    this.show = !this.show;
    this.passwordField.nativeElement.type = this.show ? 'input' : 'password';
  }
}
